module.exports = __webpack_public_path__ + "static/media/shovel.f7681ffb.svg";